/**
 * @deprecated: use from src\features\Common\modules\Storage\modules\LocalStorage\utils\LocalStorage.utils.js instead
 */
export const getLocalStorageItem = (key) => {
  try {
    const value = window.localStorage.getItem(key);
    let processedValue = value;
    if (typeof value === "string") {
      /**
       * `JSON.parse()` will fail for the items which were set in
       * the browser before this wrapper function was deployed,
       * because they were plain strings (not processed using
       * `JSON.stringify()`).
       */
      try {
        processedValue = JSON.parse(value);
      } catch {
        processedValue = value;
      }
    }
    return processedValue;
  } catch {
    return null;
  }
};

/**
 * @deprecated: use from src\features\Common\modules\Storage\modules\LocalStorage\utils\LocalStorage.utils.js instead
 */
export const setLocalStorageItem = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

/**
 * @deprecated: use from src\features\Common\modules\Storage\modules\LocalStorage\utils\LocalStorage.utils.js instead
 */
export const removeLocalStorageItem = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch {}
};

/**
 * @deprecated: use from src\features\Common\modules\Storage\modules\SessionStorage\utils\SessionStorage.utils.js instead
 */
export const setSessionStorageItem = (key, value) => {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch {}
};

/**
 * @deprecated: use from src\features\Common\modules\Storage\modules\SessionStorage\utils\SessionStorage.utils.js instead
 */
export const getSessionStorageItem = (key) => {
  try {
    const value = window.sessionStorage.getItem(key);
    let processedValue = value;
    if (typeof value === "string") {
      /**
       * `JSON.parse()` will fail for the items which were set in
       * the browser before this wrapper function was deployed,
       * because they were plain strings (not processed using
       * `JSON.stringify()`).
       */
      try {
        processedValue = JSON.parse(value);
      } catch {
        processedValue = value;
      }
    }
    return processedValue;
  } catch {
    return null;
  }
};

/**
 * @deprecated: use from src\features\Common\modules\Storage\modules\SessionStorage\utils\SessionStorage.utils.js instead
 */
export const removeSessionStorageItem = (key) => {
  try {
    window.sessionStorage.removeItem(key);
  } catch {}
};
